import type { SVGProps } from 'react';
const SvgPagLeftArrowTwo = (props: SVGProps<SVGSVGElement>) => (
  
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.56 12L11.5 11.06L8.44667 8L11.5 4.94L10.56 4L6.56 8L10.56 12Z"
      fill={props.fill}
    />
  </svg>
);
export default SvgPagLeftArrowTwo;
